import {createSlice} from '@reduxjs/toolkit';
const initialState ={
    isLoading:false,
    loadingMsg:"uploading photo:99% complete."
}
export const loaderSlice = createSlice({
    name:"detectLoader",
    initialState,
    reducers:{
        setIsLoading:(state,action) => {
            state.isLoading = action.payload
        },
        setLoadingMsg:(state,action) => {
            state.loadingMsg = action.payload
        }
    }

});

export const {setIsLoading,setLoadingMsg} = loaderSlice.actions;
export default loaderSlice.reducer;